import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaArrowLeft, FaPrint } from 'react-icons/fa';

import { Bloco, CabecalhoCard, Rodape, Secao, TituloBloco, TrSubTotal } from './styles';
import { TabelaContainer, Table, Th, Td, Tr } from '../Tabela/styles';
import Pagina from '../Pagina';
import Button from '../Button';

import { IRelatorioData } from '../../types/Relatorio';
import { Campo } from '../FichaCadastroGenerico';

export default function Relatorio() {
  const location = useLocation();
  const navigate = useNavigate();

  const data: IRelatorioData = location.state?.data;
  const filtros = location.state?.filtros;

  const campos: Campo[] = location.state?.campos;

  if (!data) return null;

  const cabecalho = data.cabecalho;

  return (
    <Pagina
      titulo={cabecalho?.titulo || 'Relatório'}
      acoes={
        <>
          <Button texto='Voltar' variante='secundario' icone={<FaArrowLeft />} onClick={() => navigate(-1)} />
          <Button texto='Imprimir' icone={<FaPrint />} onClick={() => window.print()} />
        </>
      }
    >
      <CabecalhoCard>
        {cabecalho?.empresa && <span className='empresa'>{cabecalho.empresa}{cabecalho?.filial && ` - ${cabecalho.filial}`}</span>}
        {cabecalho?.emissao && <span>Emissão: {cabecalho.emissao}</span>}
        {filtros && Object.entries(filtros).map(([key, value]) => {
          if (!value) return null;

          const campo = campos?.find((c) => c.campo === key);

          return (
            <span key={key}>
              {campo?.label || key}: {campo?.tipinp === 'checkbox'
                ? 'Sim'
                : campo?.tipinp === 'select'
                  ? campo.opcoes?.find(opcao => opcao.valor === String(value))?.rotulo ?? value as string
                  : value as string}
            </span>
          );
        })}
      </CabecalhoCard>

      {data && data.relatorio.map((grupo, grupoIndex) => (
        <Secao key={grupoIndex}>
          {grupo.dados.map((dado, dadoIndex: number) => (
            <Bloco key={dadoIndex}>
              {dado.titulo && <TituloBloco>{dado.titulo}</TituloBloco>}
              {(dado.itens.length > 0 || (dado?.subTotal && dado.subTotal.length > 0)) && (
                <TabelaContainer>
                  <Table>
                    {dado.itens.length > 0 && (
                      <>
                        <thead>
                          <tr>
                            {Object.entries(grupo.layout).map(([key, layout]) => (
                              <Th key={key} $numero={layout.alinhamento === 'Direita'}>
                                {layout.caption}
                              </Th>
                            ))}
                          </tr>
                        </thead>
                        <tbody>
                          {dado.itens.map((item, iIndex: number) => (
                            <Tr key={iIndex}>
                              {Object.keys(grupo.layout).map((coluna, colunaIndex) => (
                                <Td
                                  key={colunaIndex}
                                  $numero={grupo.layout[coluna].alinhamento === 'Direita'}
                                >
                                  {(item as any)[coluna]}
                                </Td>
                              ))}
                            </Tr>
                          ))}
                        </tbody>
                      </>
                    )}
                    {'subTotal' in dado && dado?.subTotal && dado.subTotal.length > 0 && (
                      <tbody>
                        {dado.subTotal.map((item, iIndex: number) => {
                          const colunas = Object.keys(item);

                          return (
                            <TrSubTotal key={iIndex}>
                              {colunas.map((coluna, colunaIndex) => (
                                <Td
                                  key={colunaIndex}
                                  // A última coluna (valor) ocupa o resto da linha, alinhada à direita
                                  colSpan={colunaIndex === colunas.length - 1
                                    ? Math.max(1, Object.keys(grupo.layout).length - colunas.length + 1)
                                    : undefined}
                                  $numero={colunaIndex === colunas.length - 1}
                                >
                                  {(item as any)[coluna]}
                                </Td>
                              ))}
                            </TrSubTotal>
                          );
                        })}
                      </tbody>
                    )}
                  </Table>
                </TabelaContainer>
              )}
            </Bloco>
          ))}

          {grupo.rodape_layout && grupo.rodape_dados && (
            <Rodape>
              {Object.keys(grupo.rodape_layout).map((coluna, colunaIndex) => (
                <div key={colunaIndex}>
                  <span>{(grupo.rodape_layout as any)[coluna]?.caption || coluna}:</span>
                  <strong>{(grupo.rodape_dados as any)[coluna]}</strong>
                </div>
              ))}
            </Rodape>
          )}
        </Secao>
      ))}
    </Pagina>
  );
};
